import { definePlayerFeature } from "../../feature.js";
import { listen } from "@videojs/utils/dom";
import { isMediaPauseCapable, isMediaSeekCapable, isMediaSourceCapable } from "@videojs/media";
//#region src/dom/store/features/playback.ts
const playbackFeature = definePlayerFeature({
	name: "playback",
	state: ({ target }) => ({
		paused: true,
		ended: false,
		started: false,
		waiting: false,
		play() {
			return target().media.play();
		},
		pause() {
			const { media } = target();
			if (isMediaPauseCapable(media)) media.pause();
		},
		togglePaused() {
			const media = target().media;
			if (!isMediaPauseCapable(media)) return false;
			if (media.paused) {
				media.play();
				return true;
			}
			media.pause();
			return false;
		}
	}),
	attach({ target, signal, set }) {
		const { media } = target;
		if (!isMediaPauseCapable(media) || !isMediaSeekCapable(media) || !isMediaSourceCapable(media)) return;
		let starvedAt = null;
		const sync = () => {
			const starved = media.readyState < HTMLMediaElement.HAVE_FUTURE_DATA && !media.paused;
			if (!starved) starvedAt = null;
			else starvedAt ??= media.currentTime;
			set({
				paused: media.paused,
				ended: media.ended,
				started: !media.paused || media.currentTime > 0,
				waiting: starved && starvedAt === media.currentTime
			});
		};
		const starve = () => {
			starvedAt = media.currentTime;
			sync();
		};
		sync();
		listen(media, "emptied", starve, { signal });
		listen(media, "play", starve, { signal });
		listen(media, "pause", sync, { signal });
		listen(media, "ended", sync, { signal });
		listen(media, "playing", sync, { signal });
		listen(media, "waiting", starve, { signal });
		listen(media, "seeking", starve, { signal });
		listen(media, "seeked", sync, { signal });
		listen(media, "canplay", sync, { signal });
		listen(media, "timeupdate", sync, { signal });
	}
});
//#endregion
export { playbackFeature };

//# sourceMappingURL=playback.js.map